module.exports = __webpack_public_path__ + "static/media/20.b17bb9ca.png";